import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './style.scss';

import { EntityId } from "@reduxjs/toolkit";
import NavDropdown from "../NavDropdown";

interface itemInterface {
  id: number;
  name: string;
  url: string;
  icon: any;
  parent_id?: number | null;
  subcategories?: number[];
}

interface itemsInterface {
  [key: string]: itemInterface
}

interface propsInterface {
  items: itemsInterface | undefined;
  itemIds: EntityId[] | undefined;
  activeId: number | undefined;
}

const NavBar2 = ({ items, itemIds, activeId }: propsInterface) => {
  if (!items || !itemIds) {
    return null;
  }

  return (
    <div className='v-navbar2'>
      <div className='v-nav'>
        {
          itemIds.map(key => {
            const { name, url, icon, id, subcategories } = items[key];

            if (Array.isArray(subcategories) && subcategories.length) {
              return (
                <NavDropdown
                  key={id}
                  items={items}
                  itemIds={subcategories}
                  activeId={activeId}
                  placement='bottomLeft'
                  popoverProps={{
                    placement: 'bottomLeft',
                    overlayClassName: 'v-navbar2-dropdown'
                  }}
                >
                  <span
                    className={'v-item v-parent' + (activeId && subcategories.includes(activeId) ? ' active' : '')}
                  >
                    <FontAwesomeIcon icon={icon} />{name}
                  </span>
                </NavDropdown>
              )
            } else {
              return (
                <Link key={id} to={url} className={'v-item' + (activeId === id ? ' active' : '')}>
                  <FontAwesomeIcon icon={icon} />{name}
                </Link>
              )
            }
          })
        }
      </div>
    </div>
  );
}

export default NavBar2;